import idb from "../idb";
import md5 from "../../md5"

export default {	

	async doHousekeeping(maxCacheAgeHours) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["apirequests"], "readwrite");
			trans.oncomplete = () => {
				resolve(apirequests);
			};

			const store = trans.objectStore("apirequests");
			let apirequests = [];

			store.openCursor().onsuccess = (e) => {
				const cursor = e.target.result;
				if (cursor) {
					const minAgeMs =
						Date.now() - 1000 /* seconds */ * 60 /* minutes */ * 60 /* hours */ * maxCacheAgeHours;
					// console.log(cursor.value.timestamp, minAgeMs)
					if (cursor.value.timestamp < minAgeMs) {
						// console.log('delete!');
						cursor.delete();
					}
					cursor.continue();
				}
			};
		});
	},

	async clear() {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["apirequests"], "readwrite");
			trans.oncomplete = () => {
				resolve();
			};

			const store = trans.objectStore("apirequests");
			store.clear();
		});	
	},

	async deleteAPIRequest(apirequest) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["apirequests"], "readwrite");
			trans.oncomplete = () => {
				resolve();
			};

			const store = trans.objectStore("apirequests");
			store.delete(apirequest.id);
		});
	},

	async getAPIRequests() {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["apirequests"], "readonly");
			trans.oncomplete = () => {
				resolve(apirequests);
			};

			const store = trans.objectStore("apirequests");
			let apirequests = [];

			store.openCursor().onsuccess = (e) => {
				const cursor = e.target.result;
				if (cursor) {
					apirequests.push(cursor.value);
					cursor.continue();
				}
			};
		});
	},

	async getAPIRequestByURL(url, data) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["apirequests"], "readonly");
			const store = trans.objectStore("apirequests");
			const request = store.get(md5(`${url}/${JSON.stringify(data)}`));

			request.onsuccess = (e) => {
				resolve(e.target.result);
			};
		});
	},

	async saveAPIRequest(apirequest) {
		const db = await idb.getDb();

		return new Promise((resolve) => {
			const trans = db.transaction(["apirequests"], "readwrite");
			trans.oncomplete = () => {
				resolve();
			};

			const store = trans.objectStore("apirequests");
			apirequest.url = md5(`${apirequest.url}/${JSON.stringify(apirequest.data)}`);
			delete(apirequest.data);
			store.put(apirequest);
		});
	}

};